import { createFeatureSelector, createSelector } from "@ngrx/store";
import { ValuationLandmarkState } from "../_reducers/valuation-landmark.reducer";

export const selectValuationLandmarkState = createFeatureSelector<ValuationLandmarkState>('valuation-landmarks')
export const selectValuationLandmarks = createSelector(
    selectValuationLandmarkState,
    state => state.landmarks
)